// @flow
import * as React from 'react';
import Grid from 'styled-components-grid';
import type { Element } from 'react';

import TeaserImageCopy from '@components/TeaserImageCopy';
import { StyledCoverMaxWidth, StyledItem } from './styles';

import type { Props } from './types';

const TeaserGroupTrio = ({
  images,
  headlines,
  copies,
  disableAnimations,
  imgix,
  className
}: Props): Element<any> => (
  <StyledCoverMaxWidth className={className}>
    <Grid halign="justify">
      {Array(3)
        .fill()
        .map((_, n) => (
          // eslint-disable-next-line react/no-array-index-key
          <StyledItem key={n} size={{ mobile: 1, desktop: 1 / 3 }}>
            <TeaserImageCopy
              imageUrl={images[n]}
              headline={headlines[n]}
              copy={copies[n]}
              index={n}
              disableAnimations={disableAnimations}
              imgix={imgix}
            />
          </StyledItem>
        ))}
    </Grid>
  </StyledCoverMaxWidth>
);

export default TeaserGroupTrio;
